var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal-content" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        attrs: { role: "dialog", "aria-modal": "true", "aria-label": _vm.title }
      },
      [
        _c("div", { staticClass: "modal__container" }, [
          _c(
            "div",
            { staticClass: "modal__ui-block", on: { click: _vm.close } },
            [_vm._t("blocker")],
            2
          ),
          _c("div", { staticClass: "modal__content overflow-hidden" }, [
            !_vm.preventDismiss
              ? _c(
                  "div",
                  {
                    staticClass: "modal__close",
                    attrs: {
                      tabindex: "0",
                      role: "button",
                      "aria-label": "close modal"
                    },
                    on: {
                      click: _vm.close,
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.close($event)
                      },
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        ) {
                          return null
                        }
                        if (!$event.shiftKey) {
                          return null
                        }
                        if ($event.ctrlKey || $event.altKey || $event.metaKey) {
                          return null
                        }
                        return _vm.focusLastElement($event)
                      }
                    }
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                      _c("path", {
                        attrs: {
                          d:
                            "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                        }
                      })
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "modal__header" }, [
              _c("h5", { staticClass: "text-4xl font-bold" }, [
                _vm._v(_vm._s(_vm.title))
              ])
            ]),
            _c(
              "div",
              { staticClass: "modal__controls" },
              [_vm._t("controls")],
              2
            ),
            _c(
              "div",
              {
                directives: [{ name: "lazy-load", rawName: "v-lazy-load" }],
                staticClass: "modal__body",
                class: {
                  "modal__body--border": _vm.showBorder,
                  "modal__body--full": _vm.fullBody
                }
              },
              [_vm._t("body")],
              2
            ),
            _vm.hasFooter
              ? _c(
                  "div",
                  { staticClass: "modal__footer" },
                  [_vm._t("footer")],
                  2
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }